import { render } from "./Sidebar-SuperAdmin.vue?vue&type=template&id=41fe1e95&scoped=true"
import script from "./Sidebar-SuperAdmin.vue?vue&type=script&lang=js"
export * from "./Sidebar-SuperAdmin.vue?vue&type=script&lang=js"

import "./Sidebar-SuperAdmin.vue?vue&type=style&index=0&id=41fe1e95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fe1e95"]])

export default __exports__